//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import * as ActivityActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  -- Constants ----------------------
export const handleSetSchoologyAuth = (schoologyUid, cb) => {
    return async (dispatch) => {
        try {
            const response = await apis.get("schoologyRDS", `/schoology/${schoologyUid}`);
            dispatch(ActivityActions.createSchoologyAuth(response));
            if (cb && typeof cb == "function") {
                cb(response)
            }
            if (!response || !response.oauth_token) {
                return false;
            } else {
                return true;
            }
        } catch (error) {
            if (error && error.message != "Network Error") {
                logToSentry({
                message: 'setting schoology auth',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'SET_STUDENT_ACTIVITY'
            });
            }
            return false;
        }
    }
}
export const handleSetSchoologyAuthWithsjwt = async (sjwt, uid) => {
    try {
        const response = await apis.post("schoologyRDS", `/get_user_info_jwt`, {
            body: {
                "sjwt": sjwt,
                uid
            }
        });
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'setting schoology auth with sjwt',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'SET_STUDENT_ACTIVITY_WORKSHEET_STUDENT'
            });
        }
        const apiErrorMessage =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.data?.message ||
            error?.data?.error ||
            error?.message ||
            "Having issue with api calls.";
        return { "success": false, "message": apiErrorMessage };
    }
}

export const handleCreateLogs = async(data) => {
        try {
            const re = await apis.post("schoologyRDS", `/logs`, { body: data })
            if (re && re.id) {
                localStorage.setItem("log_id",re.id);
            }
        } catch (error) {
            if (error && error.message != "Network Error") {
                logToSentry({
                message: 'creating logs',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'CREATE_LESSON'
            });
            }
           
        }
}
export const handleUpdateLogs = async(data) => {
        try {
            await apis.put("schoologyRDS", `/update_logs`, { body: data })
        } catch (error) {
            if (error && error.message != "Network Error") {
                logToSentry({
                message: 'updating logs',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'UPDATE_LESSON'
            });
            }
           
        }
}
export const handleCreateSchoologyAuth = (data) => {
    return async (dispatch) => {
        try {
            await apis.post("schoologyRDS", `/schoology`, { body: data })
            dispatch(ActivityActions.createSchoologyAuth(data));
            return true;
        } catch (error) {
            if (error && error.message != "Network Error") {
                logToSentry({
                message: 'creating schoology auth',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'CREATE_STORY_AI'
            });
            }
            return false;
        }
    }
}
export const handleUserBySchoologyId = async (schoologyUid) => {
    try {
        const schoologyuser = await apis.get("schoologyRDS", `/getUserBySchoologyId/${schoologyUid}`)
        return schoologyuser;

    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting user by schoology id',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'GET_USER_BOOK_STUDENT_INSTRUCTION'
            });
        }
        return ({ error: true });
    }
}
export const handleUserBySchoologyName = async (name) => {
    if(typeof name!="string") return [];
    try {
        const firstName = name.replace(/\s\s+/g, ' ').split(" ")[0].trim();
		const lastName = name.replace(/\s\s+/g, ' ').split(" ")[1]?.trim();
        const schoologyuser = await apis.post("schoologyRDS", `/getUserByName`,{
            body: {
                firstName,
                lastName
            }
        })
        return schoologyuser;

    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting user by schoology name',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'GET_USER_BOOK_STUDENT_NOTE'
            });
        }
        return ({ error: true });
    }
}

export const handleNewUserBySchoologyName = async (name, type) => {
    if(typeof name!="string") return [];
    try {
        const schoologyuser = await apis.post("schoologyRDS", `/search_user_by_type`,{
            body: {
                title: name,
                type
            }
        })
        return schoologyuser?.data;

    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting user by schoology name',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'GET_USER_BOOK_STUDENT_NOTE'
            });
        }
        return ({ error: true });
    }
}

export const handleGetGradeCategory = (section_id, user_id, limit = 100) => async (dispatch) => {
    try {
        const response = await apis.post("schoologyRDS", `/getGradeCategories`, {
            body: {
                section_id, user_id, limit
            }
        })
        if (response && response.success) {
            dispatch(ActivityActions.setSchoologyAllClassGradeCategory(response.data))
            return response.data;

        }
        return {}
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting grade category',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'GET_GROUP_CLASS'
            });
        }
        return {};
    }
}
export const handleListSectionAssignment = (section_id, user_id, limit = 100) => async (dispatch) => {
    try {
        const response = await apis.post("schoologyRDS", `/listSectionAssignment`, {
            body: {
                section_id, user_id, limit
            }
        })
        if (response && response.success) {
            dispatch(ActivityActions.setSchoologyAssignment(response.data))
            return response.data;
        }
        return []
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing section assignment',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'LIST_STORY_AI'
            });
        }
        return [];
    }
}
export const handleUpdateSchoologyAssignment = (section_id, user_id, data , assignmentId, activityId, updateTOAllClass) => async (dispatch) => {
    try {
        const response = await apis.post("schoologyRDS", `/updateAssignment`, {
            body: {
                section_id, user_id , data , assignmentId, activityId, updateTOAllClass
            }
        })
        if (response && response.success) {
            dispatch(handleListSectionAssignment(section_id,user_id,300))
            return response.data;
        }
        return []
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating schoology assignment',
                error,
                module: 'SCHOOLOGY_AUTH',
                operation: 'UPDATE_STUDENT_ACTIVITY'
            });
        }
        return [];
    }
}
